var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menu-toggle',{staticClass:"menu"}),_vm._v(" "),_c('div',{staticClass:"search-container"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('typeahead',{staticClass:"search-input",attrs:{"default-text":_vm.placeholder}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fcadc58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Views/MainSearch.vue
// module id = 39
// module chunks = 0